import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { fetchPartnerById, fetchPartnerProductList, unregisterPartnerProduct } from '../../services/partner.service';
import { customTableStyles } from '../../utils';
import MessageContainer from '../message.component';
import WithLogin from '../withLogin.component';
import { useParams } from 'react-router-dom';
import MapPartnerProduct from './mapPartnerProduct.component'
import DataTable from 'react-data-table-component';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

const ViewPartner = props => {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({});
    const [partner, setPartner] = useState({});
    const [partnerProduct, setPartnerProduct] = useState([]);
    const [openAddForm, setOpenAddForm] = useState(false);
    const navigte = useNavigate();

    const getPartner = async () => {
        try {
            const resp = await fetchPartnerById(id);
            setPartner(resp);
        } catch (error) {
            if (
                error.response.status === 400 ||
                error.response.status === 404
            ) {
                setMessage({
                    type: 'Error',
                    message: `${error.response.data.detail}`,
                });
            }
        }
    };

    const getPartnerProducts = async () => {
        setLoading(true);
        try {
            const resp = await fetchPartnerProductList(id);
            setPartnerProduct(resp);
            setMessage({});
        } catch (error) {
            if (
                error.response.status === 400 ||
                error.response.status === 404
            ) {
                setMessage({
                    type: 'Error',
                    message: `${error.response.data.detail}`,
                });
                setPartnerProduct([])
            }
        }
        setLoading(false);
    }

    const disassociatePartnerProduct = async (id) => {
        try {
            await unregisterPartnerProduct(id);
            setMessage({
                type: 'Success',
                message: 'Partner has been unregistered with product successfully',
            });
            reloadDataTable();
        } catch (error) {
            if (
                error.response.status === 400 ||
                error.response.status === 404
            ) {
                setMessage({
                    type: 'Error',
                    message: `${error.response.data.detail}`,
                });
            }
        }
    };

    const reloadDataTable = () => {
        getPartnerProducts();
    };

    useEffect(() => {
        getPartner();
        getPartnerProducts();
        setMessage({});
    }, [props]); // eslint-disable-line react-hooks/exhaustive-deps

    const columns = [
        {
            name: 'ID',
            selector: row => row.id,
            width: '10%',
        },
        {
            name: 'Product name',
            selector: row => `${row.name}`,
        },
        {
            name: 'Product sku',
            selector: row => row.sku,
        },
        {
            key: 'action',
            text: 'Action',
            name: 'Action',
            className: 'action',
            align: 'left',
            width: '10%',
            sortable: false,
            cell: row => {
                return (
                    <Fragment>
                        {!row.has_kit_order &&
                            <span className="table-action-icon">
                                <RemoveCircleIcon
                                    titleAccess='remove'
                                    color="red"
                                    className="table-action-icon red"
                                    onClick={() => disassociatePartnerProduct(row.id)}
                                />
                            </span>
                        }
                    </Fragment>
                );
            },
        },
    ]


    return (
        <>
            {openAddForm && (
                <MapPartnerProduct
                    open={openAddForm}
                    setOpenAddForm={setOpenAddForm}
                    reloadDataTable={reloadDataTable}
                    partnerId={id}
                />
            )}
            <div className="mt-2">
                <div className="pageHeader">
                    <span id="header">
                        <h4>Partner Details</h4>
                    </span>
                </div>
                <hr />
                {message && message.type && <MessageContainer message={message} />}
                <button
                    className="btn btn-secondary"
                    style={{ float: 'inline-end' }}
                    onClick={e => {
                        navigte('/partners/');
                    }}
                >
                    Back
                </button>
                <div className="col-md-12">
                    <span className="txt-label w-15">Name</span>
                    <span className="txt-label-value">
                        {partner.name}
                    </span>
                </div>
                <div className="col-md-12">
                    <span className="txt-label w-15">Contact Name</span>
                    <span className="txt-label-value">{partner.contact_name}</span>
                </div>
                <div className="col-md-12">
                    <span className="txt-label w-15">Email</span>
                    <span className="txt-label-value">{partner.contact_email}</span>
                </div>
                <div className="col-md-12">
                    <span className="txt-label w-15">Mobile Number</span>
                    <span className="txt-label-value">
                        {partner.contact_number}
                    </span>
                </div>
                <div className="col-md-12">
                    <span className="txt-label w-15">SubDomain</span>
                    <span className="txt-label-value">{partner.subdomain} <a rel="noreferrer" target='_blank' href={partner.domain}>({partner.domain})</a></span>
                </div>
                <div style={{ marginBottom: '10px', float: 'right' }}>
                    <button
                        className="btn btn-primary"
                        onClick={() => setOpenAddForm(true)}>
                        Assign Product
                    </button>
                </div>
                <br />
                {
                    partnerProduct.length > 0
                    &&
                    <div className="admin-list-table">
                        <DataTable
                            width="100%"
                            customStyles={customTableStyles}
                            columns={columns}
                            data={partnerProduct}
                            progressPending={loading}
                        />
                    </div>
                }
            </div>
        </>
    );
};

export default WithLogin(ViewPartner);